module.exports = __webpack_public_path__ + "img/icon-ccf.0489f729.svg";